module.exports = __webpack_public_path__ + "img/pamplona.f47cabe3.jpg";